/**
 * Modal: a window over the page that has to be dealt with before going back (cockatrice-ui `src/ui/Modal.jsx`, ported
 * to hyperscript; PLAN.md §0).
 * Same component and props as <Dialog> (open, onClose, title, subtitle, size, footer, inline);
 * use whichever name reads better. On phones it becomes a full-screen sheet.
 */
import Dialog from './Dialog.ts';
import type { DialogProps } from './Dialog.ts';
import { component } from './solid.ts';
import type { Child } from './solid.ts';

/** Modal takes exactly the Dialog props: open, onClose, title, eyebrow, description, size, footer, footerStart, inline. */
export type ModalProps = DialogProps;

export default function Modal(props: ModalProps): Child {
  return component(Dialog, props);
}
